import {
  setActiveDataBitrixChatBot,
  setDataBitrixChatBot,
  setIsErrorBitrixChatBot,
  setIsUpdateBitrixChatBot,
} from "../../../../store/slices/bitrixChatBotSlice";
import { removeUser } from "../../../../store/slices/userSlice";
import { errorToast } from "../../../methods/toast";
import { $authHost } from "../../http";

let userId = localStorage.getItem("@storage_User_Id");

//Получение
export const initBitrixBot = (dataReq, setLoading, setIsConnected) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.post(
        `/integrations/bitrix/chatbot`,
        dataReq
      );

      if (data.code === 200) {
        setIsConnected(true);
        dispatch(getIntegrationsBitrixBotList(userId));
      } else {
        errorToast("Ошибка инициализации Bitrix Bot");
      }
    } catch (error) {
      if (!error.response) {
        errorToast("Ошибка сети. Проверьте подключение.");
      } else if (error.response.status === 401) {
        dispatch(removeUser());
      } else if (error.response.status === 500) {
        errorToast("Ошибка сервера. Попробуйте позже.");
      } else if (error.response.data?.message === "error: invalid api url") {
        errorToast("Неверный API URL, повторите попытку.");
      } else if (
        error.response.data?.message?.includes("TLS handshake timeout")
      ) {
        errorToast(
          "Произошла ошибка соединения с Bitrix. Повторите попытку позже."
        );
      }

      console.error("initBitrix error:", error);
    } finally {
      setLoading(false);
    }
  };
};

// Удаление интеграции
export const deleteIntegrationBitrixBot = (dataReq, setLoading, navigate) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.post(
        `/integrations/bitrix/delete`,
        dataReq
      );
      if (data.code === 200) {
        dispatch(setActiveDataBitrixChatBot(null));
        localStorage.removeItem("dataActiveBitrixChatBot");
        dispatch(getIntegrationsBitrixBotList(dataReq.userId));
        navigate("/integration");
        setLoading(false);
      } else {
        setLoading(false);
        errorToast("Ошибка удаления интеграции");
      }
    } catch (error) {
      setLoading(false);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера, попробуйте позже");
        }
      } else if (error.request) {
        errorToast("Нет ответа от сервера, проверьте соединение");
      } else {
        errorToast("Произошла неизвестная ошибка");
      }
      console.log("deleteIntegrationBitrix error:", error);
    }
  };
};

// Получение конкретной интеграции
export const getIntegrationBitrixBot = (
  userId,
  chatBotId,
  setLoading = () => {}
) => {
  return async (dispatch) => {
    dispatch(setIsErrorBitrixChatBot(false));
    setLoading(true);
    try {
      const { data } = await $authHost.get(
        `/integrations/bitrix/chatbot?userId=${userId}&chatBotId=${chatBotId}`
      );
      if (data.code === 200) {
        setLoading(false);
        dispatch(setActiveDataBitrixChatBot(data?.chatBot));
        localStorage.setItem("activeBitrixBot", JSON.stringify(data?.chatBot));
      } else {
        setLoading(false);
        errorToast("Не удалось получить интеграцию с Bitrix");
        dispatch(setIsErrorBitrixChatBot(true));
      }
    } catch (error) {
      dispatch(setIsErrorBitrixChatBot(true));
      setLoading(false);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера, попробуйте позже");
        }
      } else if (error.request) {
        errorToast("Нет ответа от сервера, проверьте соединение");
      } else {
        errorToast("Произошла неизвестная ошибка");
      }
      console.log("getIntegrationBitrix error:", error);
    }
  };
};

// Получение списка интеграций
export const getIntegrationsBitrixBotList = (userId) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.get(
        `/integrations/bitrix/chatbot-list?userId=${userId}`
      );
      if (data.code === 200) {
        if (data.chatBots) {
          dispatch(setDataBitrixChatBot(data.chatBots));
          localStorage.setItem(
            "dataBitrixChatBot",
            JSON.stringify(data?.chatBot)
          );
        }
      } else {
        errorToast("Не удалось загрузить список ботов BitrixBot");
      }
      // console.log("getIntegrationsBitrixBotList", data);
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера, попробуйте позже");
        }
      } else if (error.request) {
        errorToast("Нет ответа от сервера, проверьте соединение");
      } else {
        errorToast("Произошла неизвестная ошибка");
      }
      console.log("getIntegrationsBitrixBotList error:", error);
    }
  };
};

// Обновление воронки
export const configureBitrixChatBot = (dataReq) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.put(
        `/integrations/bitrix/chatbot-configure`,
        dataReq
      );
      if (data.code === 200) {
        dispatch(getIntegrationsBitrixBotList(userId));
        dispatch(setIsUpdateBitrixChatBot(false));
      } else {
        errorToast("Не удалось обновить категорию Bitrix Chat Bot");
      }
      // console.log("configureBitrixChatBot", data);
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера, попробуйте позже");
        }
      } else if (error.request) {
        errorToast("Нет ответа от сервера, проверьте соединение");
      } else {
        errorToast("Произошла неизвестная ошибка");
      }
      console.log("configureBitrixChatBot error:", error);
    }
  };
};
